// extracted by mini-css-extract-plugin
export default {"wrapper":"TestimonialSlice_wrapper__IF6SA","content":"TestimonialSlice_content__mvEX9","text":"TestimonialSlice_text__s-Xod","author":"TestimonialSlice_author__rHxwx"};